import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    table: {
      borderCollapse: 'collapse',
      margin: '0 5px 40px',
      width: 'calc(100% - 10px)'
    },
    tableRow: {
      alignItems: 'center',
      backgroundColor: '#fff',
      border: 0,
      borderRadius: '8px',
      display: 'flex',
      width: '100%'
    },
    tableHeadRow: {
      padding: '10px 0px'
    },
    tableBodyRow: {
      boxShadow: '0 1px 9px 0 rgba(0, 0, 0, 0.2)',
      padding: '0px'
    },
    tableCell: {
      background: '#ffffff00',
      border: 0,
      flex: '1',
      fontSize: '22px',
      whiteSpace: 'nowrap',
      '&:first-child': {
        paddingLeft: '24px'
      },
      '&:last-child': {
        paddingRight: '24px'
      },
      [theme.breakpoints.down('lg')]: {
        paddingLeft: '12px',
        paddingRight: '12px',
        '&:first-child': {
          paddingLeft: '16px'
        },
        '&:last-child': {
          paddingRight: '16px'
        }
      }
    },
    tableHeadCell: {
      fontWeight: 600,
      lineHeight: 1.13
    },
    tableBodyCell: {
      overflowWrap: 'anywhere'
    },
    tableCollapseCell: {
      flex: '0 0 91px',
      [theme.breakpoints.down('lg')]: {
        padding: '5px',
        flex: '0 0 72px'
      }
    },
    tableDetailsCell: {
      flex: '0 0 18%'
    },
    tableQuantityCell: {
      flex: '0 0 18%',
      [theme.breakpoints.down('lg')]: {
        flex: '0 0 15%'
      }
    },
    tablePriceCell: {
      flex: '0 0 18%',
      [theme.breakpoints.down('lg')]: {
        flex: '0 0 16%'
      }
    },
    tableRemoveCell: {
      flex: '0 0 110px',
      [theme.breakpoints.down('lg')]: {
        flex: '0 0 76px'
      }
    },
    tableNumberCell: {
      textAlign: 'right'
    },
    tableItemsRow: {
      background: 'rgb(239 239 239 / 50%)',
      border: '3px solid rgba(224, 224, 224, 1)',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      borderTop: 0,
      display: 'flex',
      width: '100%'
    },
    tableItemsCell: {
      borderRadius: '8px',
      flex: '1',
      margin: '0 -3px',
      padding: '0px'
    },
    itemsTable: {
      borderBottom: '3px solid rgba(224, 224, 224, 1)',
      margin: '10px 0px !important',
      '&:last-child': {
        border: 0
      }
    },
    expandIcon: {
      border: `3px solid ${theme.palette.primary.main}`,
      borderRadius: '50%',
      color: theme.palette.primary.main
    },
    descriptionBox: {
      background: 'transparent',
      flex: '1 1 0%',
      lineHeight: 1.5,
      whiteSpace: 'normal'
    }
  })
);
